import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { receiveReturn } from "../../api/apiReturns";
import parseError from "../../utils/parseError";

export const useReceiveReturn = () => {
    const queryClient = useQueryClient();

    const { mutate: receiveReturnMutate, isPending: isReceiving } = useMutation({
        mutationFn: ({ id, data }) => receiveReturn(id, data),
        onSuccess: (res) => {
            toast.success(res.message || "Return marked as received");
            queryClient.invalidateQueries(["returns"]);
            queryClient.invalidateQueries(["return"]);
        },
        onError: (error) => {
            toast.error(parseError(error) || "Failed to mark return as received");
        },
    });

    return { receiveReturnMutate, isReceiving };
};
